const workHours = [
    "40 o menos",
    "Entre 40 y 50",
    "Entre 50 y 60",
    "Más de 60",
  ];
  
  export default workHours;
  